<template>
  <div id="audio-bars">
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
    <div class="audio-bar" />
  </div>
</template>
